export default __webpack_public_path__ + "static/media/RhymesWeather_03.07910eb9.png";